var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{attrs:{"id":"header"}},[_c('div',{staticClass:"container",attrs:{"id":"mainHeader"}},[_c('div',{staticClass:"d-flex align-items-end"},[_c('NettoLogo')],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }